import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import { Breadcrumb, BreadcrumbItem, Card } from 'reactstrap';
import { HomeButton } from '../../components/HomeButton/home-button';
import { useStateSelector } from '../../store/selectors';
import { USER_ROLES } from '../../utils/constants';
import TimelineTemplates from './MarketplaceTabs/TimelineTemplates/TimelineTemplates';
import { MarketplaceBuyers } from './MarketplaceTabs/MarketplaceBuyers/MarketplaceBuyers';
import Engagements from './MarketplaceTabs/Engagements/Engagements';
import { useSearchParams } from 'react-router-dom';
import DocumentTemplates from './MarketplaceTabs/DocumentTemplates/DocumentTemplates';
import {
    AdminMarketplaceTab,
    AdminMarketplaceTabs,
} from '../../slices/marketplace/timeline/models/enums/admin-marketplace-tab.enum';
import MarketplaceSettings from './MarketplaceTabs/MarketplaceSettings/MarketplaceSettings';
import { useFeatureFlag } from '../../custom-hooks/useFeatureFlag';
import { FeatureFlagsEnum } from '../FeatureFlags/FeatureFlags.enum';
import { MarketplaceBrokers } from './MarketplaceTabs/MarketplaceBrokers/MarketplaceBrokers';

const AdminMarketplace = () => {
    const tabComponents = [
        { id: AdminMarketplaceTab.Engagements, content: () => <Engagements /> },
        {
            id: AdminMarketplaceTab.TimelineTemplates,
            content: () => <TimelineTemplates />,
        },
        {
            id: AdminMarketplaceTab.MarketplaceBuyers,
            content: () => <MarketplaceBuyers />,
        },
        {
            id: AdminMarketplaceTab.MarketplaceBrokers,
            content: () => <MarketplaceBrokers />,
        },
        {
            id: AdminMarketplaceTab.DocumentTemplates,
            content: () => <DocumentTemplates />,
        },
        {
            id: AdminMarketplaceTab.MarketplaceSettings,
            content: () => <MarketplaceSettings isTemplate={true} />,
        },
    ];
    const isSellers28Implemented = useFeatureFlag(
        FeatureFlagsEnum.FF_MrktplcSellers_2_8
    );

    const [searchParams, setSearchParams] = useSearchParams({});
    const userSummary = useStateSelector((state) => state.userSummary.summary);
    const isAdmin = userSummary.roleId === USER_ROLES.ADMIN;

    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        const value = searchParams.get('tab');
        const numberValue = Number(value);
        if (
            value &&
            numberValue &&
            tabComponents.some((tab) => tab.id === numberValue)
        ) {
            setActiveTab(numberValue);
        } else {
            setSearchParams({
                tab: tabComponents[0].id.toString(),
            });
        }
    }, [searchParams]);

    const renderTabContent = () => {
        const activeTabData = tabComponents.find((tab) => tab.id === activeTab);
        return activeTabData ? activeTabData.content() : <></>;
    };

    const renderTabs = () => {
        return (
            <Card className="main-card">
                <div className="body_white_box practice-page-tabs m-0">
                    <div className="body_inner_content">
                        <div className="RRT__container">
                            <div className="RRT__tabs body-tabs">
                                {AdminMarketplaceTabs?.filter(
                                    (t) =>
                                        isSellers28Implemented ||
                                        t.id !==
                                            AdminMarketplaceTab.MarketplaceBrokers
                                ).map((item) => {
                                    return (
                                        <div
                                            key={item.id}
                                            className={
                                                activeTab === item.id
                                                    ? 'RRT__tab RRT__tab--first RRT__tab--selected'
                                                    : 'RRT__tab'
                                            }
                                            onClick={() => {
                                                setActiveTab(item.id);
                                                setSearchParams({
                                                    tab: item.id.toString(),
                                                });
                                            }}>
                                            {item.content}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        {renderTabContent()}
                    </div>
                </div>
            </Card>
        );
    };

    const renderMarketplacePage = () => {
        return (
            <div>
                <div>
                    <div className="main-title-content">
                        <div className="title-breadcrumb">
                            <div className="page-title">
                                <h3>Marketplace Admin</h3>
                            </div>
                            <Breadcrumb>
                                <BreadcrumbItem>
                                    <HomeButton />
                                </BreadcrumbItem>
                                <BreadcrumbItem active>
                                    Marketplace Admin Home
                                </BreadcrumbItem>
                            </Breadcrumb>
                        </div>
                    </div>
                </div>

                {renderTabs()}
            </div>
        );
    };

    return (
        <Layout>
            {isAdmin ? (
                renderMarketplacePage()
            ) : (
                <h1>You don't have an access to see this page.</h1>
            )}
        </Layout>
    );
};

export default AdminMarketplace;
